import { makeStyles } from '@material-ui/core'
import React from 'react'

import Typography from './Typography'

const useStyles = makeStyles(theme => ({
  sidePanel: {
    background: 'white',
    borderRadius: theme.shape.borderRadius,
    boxShadow: `0px 2px 4px 0px ${theme.palette.darkGreen.main}42`,
    padding: theme.spacing(2),
  },
  sidePanelItem: {
    marginBottom: theme.spacing(2),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  sideHeader: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing(1),
  },
  sideHeaderIcon: {
    marginRight: theme.spacing(0.5),
  },
}))

const SidePanel = ({ children }) => {
  const classes = useStyles()
  return <div className={classes.sidePanel}>{children}</div>
}

const SidePanelItem = ({ children, Icon, title }) => {
  const classes = useStyles()
  return (
    <div className={classes.sidePanelItem}>
      {title && (
        <Typography
          className={classes.sideHeader}
          variant="h5"
          color="lightGreen"
        >
          {Icon && <Icon className={classes.sideHeaderIcon} fontSize="small" />}
          {title}
        </Typography>
      )}
      {children}
    </div>
  )
}

SidePanel.Item = SidePanelItem

export default SidePanel
